<template>
    <transition name="toast-fade">
        <div v-if="visible" class="app-toast" :class="`app-toast--${type}`">
            {{ msg }}
        </div>
    </transition>
</template>

<script>
// Listens for `$root.$emit('toast', { msg, type })` anywhere in the app.
export default {
    name: 'AppToast',
    data() {
        return {
            visible: false,
            msg: '',
            type: 'error',
            timer: null
        };
    },
    created() {
        this.$root.$on('toast', this.show);
    },
    beforeDestroy() {
        this.$root.$off('toast', this.show);
        clearTimeout(this.timer);
    },
    methods: {
        show({ msg, type = 'error' }) {
            clearTimeout(this.timer);
            this.msg = msg;
            this.type = type;
            this.visible = true;
            this.timer = setTimeout(() => { this.visible = false; }, 3000);
        }
    }
};
</script>

<style lang="scss" scoped>
.app-toast {
    position: fixed;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    box-sizing: border-box;
    max-width: calc(100vw - 32px);
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    font-family: 'Urbanist', sans-serif;
    text-align: center;
    white-space: normal;
    word-break: break-word;
    pointer-events: none;
}

.app-toast--error {
    background: var(--toast-error-bg);
    border: 1px solid var(--toast-error);
    color: var(--toast-error);
}

.app-toast--success {
    background: var(--toast-success-bg);
    border: 1px solid var(--toast-success);
    color: var(--toast-success);
}

.toast-fade-enter-active,
.toast-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-10px);
}
</style>
